import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../section-components/Button'
import { TextboxMobile } from '../../section-components/Textbox'
import styles from './Form.module.scss'

function FormMobile({
  t,
  userFields,
  validFields,
  validateChange,
  handleBlur,
  handleSubmit,
  isFormValid,
  onCancel
}) {
  return (
    <div className={styles['edit-account-form-mobile']}>
      <label htmlFor="fieldsHeader" className={styles['fields-header-mobile']}>{t('fields-required')}</label>
      <div className={styles['form-field-mobile']}>
        <label htmlFor="primaryEmail" className={styles['form-label-mobile']}>{t('label-email')}</label>
        <span className={styles['form-secondary-text-mobile']}>{t('support-text-primary-email')}</span>
        <TextboxMobile
          disabled
          value={userFields.email}
          onBlur={() => handleBlur('email')}
          error={validFields.email.hasError}
          supportText={t('validation-email')}
          required
        />
      </div>
      <div className={styles['form-field-mobile']}>
        <label htmlFor="secondaryEmail" className={styles['form-label-mobile']}>{t('label-second-email-optional')}</label>
        <span className={styles['form-secondary-text-mobile']}>{t('support-text-second-email')}</span>
        <TextboxMobile
          value={userFields.secondEmail}
          onChange={(e) => validateChange('secondEmail', e.target.value)}
          onBlur={() => handleBlur('secondEmail')}
          error={validFields.secondEmail.hasError}
          supportText={t('validation-email')}
        />
      </div>

      <div className={styles['buttons-mobile']}>
        <Button
          text={t('button-save-changes')}
          buttonStyle="cta-red-oval-edit-profile-mobile"
          onClick={handleSubmit}
          disabled={!isFormValid}
        />
        <Button
          text={t('button-cancel')}
          buttonStyle="cta-grey-oval-edit-profile-mobile"
          onClick={onCancel}
        />
      </div>
    </div>
  )
}

FormMobile.propTypes = {
  t: PropTypes.func.isRequired,
  userFields: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    secondEmail: PropTypes.string,
    mobilePhone: PropTypes.string,
  }).isRequired,
  validFields: PropTypes.shape({
    firstName: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    lastName: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    email: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    secondEmail: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    mobilePhone: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
  }).isRequired,
  validateChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default FormMobile
